import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './BadgeHighlight.css';

function BadgeHighlight({ children, className, isOff, ...rest }) {
  return (
    <div
      className={classNames(
        'BadgeHighlight',
        {
          'BadgeHighlight--off': isOff,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

BadgeHighlight.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  className: PropTypes.string,
  isOff: PropTypes.bool,
};

BadgeHighlight.defaultProps = {
  className: undefined,
  isOff: true,
};

export default BadgeHighlight;



// WEBPACK FOOTER //
// ../ui-components/components/BadgeHighlight/index.jsx